// extracted by mini-css-extract-plugin
export default {"invitationIcon":"InvitationButton-module__invitationIcon--__M9V","invitationText":"InvitationButton-module__invitationText--yNhEz"};